import { FormEvent, useState } from "react"
import { useNavigate } from "react-router-dom"
import { changePassword } from "../../lib/auth"
import { useEmpresa } from "../../app/context/EmpresaContext"
import { config } from "../../lib/config"

export const ChangePasswordPage = () => {
  const navigate = useNavigate()
  const { me, reload } = useEmpresa()
  const [currentPassword, setCurrentPassword] = useState("")
  const [newPassword, setNewPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault()
    setError(null)
    if (newPassword !== confirmPassword) {
      setError("A confirmação não coincide com a nova senha.")
      return
    }
    setLoading(true)
    try {
      await changePassword(currentPassword, newPassword)
      await reload()
      navigate("/app", { replace: true })
    } catch (err) {
      setError(err instanceof Error ? err.message : "Não foi possível atualizar a senha.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 shadow-sm"
      >
        <h1 className="text-xl font-semibold text-slate-900">Defina sua nova senha</h1>
        <p className="mt-2 text-sm text-slate-600">
          {me?.must_change_password
            ? "Por segurança, troque a senha provisória antes de usar o painel."
            : "Atualize a senha da sua conta."}
        </p>

        <label className="mt-6 block text-sm font-medium text-slate-700" htmlFor="current-password">
          Senha atual
        </label>
        <input
          id="current-password"
          type="password"
          autoComplete="current-password"
          required
          minLength={8}
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/30"
        />

        <label className="mt-4 block text-sm font-medium text-slate-700" htmlFor="new-password">
          Nova senha
        </label>
        <input
          id="new-password"
          type="password"
          autoComplete="new-password"
          required
          minLength={8}
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/30"
        />

        <label className="mt-4 block text-sm font-medium text-slate-700" htmlFor="confirm-password">
          Confirmar nova senha
        </label>
        <input
          id="confirm-password"
          type="password"
          autoComplete="new-password"
          required
          minLength={8}
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/30"
        />

        {error ? <p className="mt-3 text-sm text-red-600">{error}</p> : null}

        <button
          type="submit"
          disabled={loading}
          className="mt-6 w-full rounded-lg bg-brand-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-brand-700 disabled:opacity-60"
        >
          {loading ? "Salvando…" : "Salvar nova senha"}
        </button>

        <p className="mt-4 text-center text-xs text-slate-500">{config.appName}</p>
      </form>
    </main>
  )
}
